import type * as React from 'react';

import type { NotificationBadgeProps } from '@xing-com/badge';

import * as Styled from './tag.styles';
import type { ProfileProps } from './tag.types';

type TagContentProps = {
  badgeProps?: NotificationBadgeProps;
  badgeSpacing?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  leadingIcon?: React.ReactNode;
  maxWidth?: string;
  profile?: ProfileProps;
  selected?: boolean;
  showMiniBadge?: boolean;
  size?: 'small' | 'medium';
  slotContent?: React.ReactNode;
  trailingIcon?: React.ReactNode;
};

export const TagContent = ({
  badgeProps,
  badgeSpacing,
  children,
  disabled,
  leadingIcon,
  maxWidth,
  profile,
  selected,
  showMiniBadge,
  size,
  slotContent,
  trailingIcon,
}: TagContentProps): JSX.Element => (
  <>
    {showMiniBadge && <Styled.MiniBadgeContainer $disabled={disabled} />}
    {leadingIcon && <Styled.IconContainer>{leadingIcon}</Styled.IconContainer>}
    {profile && (
      <Styled.ProfileImageContainer $size={size}>
        <Styled.Profile
          $disabled={disabled}
          profileName={profile.name}
          src={profile.image}
          size="xxsmall"
        />
      </Styled.ProfileImageContainer>
    )}
    {children && (
      <Styled.TextTruncationWrapper>
        <Styled.TextTruncation $maxWidth={maxWidth}>
          {children}
        </Styled.TextTruncation>
      </Styled.TextTruncationWrapper>
    )}
    {/* Badge is only possible in selected state */}
    {badgeProps && selected && !disabled && (
      <Styled.BadgeContainer $badgeSpacing={badgeSpacing}>
        <Styled.Badge {...badgeProps} />
      </Styled.BadgeContainer>
    )}
    {slotContent && <Styled.SlotContainer>{slotContent}</Styled.SlotContainer>}
    {trailingIcon && (
      <Styled.IconContainer>{trailingIcon}</Styled.IconContainer>
    )}
  </>
);
